function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_iii_28327_6675)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.92 16.29C29.94 16.26 29.97 16.22 29.98 16.18V16.17C29.99 16.15 29.99 16.13 30 16.11C30 16.09 30.01 16.07 30.01 16.04C30.01 16.04 30.01 16.04 30.01 16.03V16.02C30.01 16.01 30.01 16 30.01 16C30.01 15.99 30.01 15.98 30.01 15.97V15.96C30.01 15.94 30 15.92 30 15.9V15.89C30 15.87 29.99 15.85 29.98 15.84V15.83C29.97 15.81 29.96 15.79 29.95 15.77C29.94 15.75 29.93 15.74 29.92 15.72L29.91 15.71C29.9 15.69 29.88 15.68 29.87 15.66C29.86 15.65 29.84 15.63 29.82 15.62L29.81 15.61C29.79 15.6 29.77 15.59 29.75 15.57C27.17 14.18 25.75 12.27 25.55 9.9C25.39 8.09 26.01 6.67 26.01 6.66C26.01 6.66 26.01 6.66 26.01 6.65C26.02 6.63 26.03 6.61 26.03 6.59C26.03 6.59 26.03 6.59 26.03 6.58C26.04 6.56 26.04 6.54 26.04 6.52C26.04 6.51 26.04 6.51 26.04 6.5C26.04 6.48 26.04 6.46 26.04 6.44C26.04 6.44 26.04 6.44 26.04 6.43C26.04 6.41 26.04 6.39 26.04 6.37V6.36C26.04 6.33 26.03 6.29 26.01 6.25C26.01 6.25 26.01 6.24 26 6.24C25.99 6.22 25.98 6.2 25.97 6.19C25.96 6.17 25.94 6.15 25.93 6.14C25.93 6.14 25.93 6.14 25.93 6.13C25.93 6.13 25.93 6.13 25.92 6.12C25.91 6.11 25.91 6.11 25.9 6.1C25.89 6.09 25.89 6.09 25.88 6.08L25.87 6.07C25.85 6.06 25.84 6.04 25.82 6.03C25.82 6.03 25.81 6.03 25.81 6.02C25.8 6.02 25.78 6.01 25.77 6C25.77 6 25.76 6 25.76 5.99C25.74 5.98 25.72 5.97 25.7 5.97C25.7 5.97 25.7 5.97 25.69 5.97C25.67 5.96 25.65 5.96 25.63 5.96C25.62 5.96 25.62 5.96 25.61 5.96C25.59 5.96 25.57 5.96 25.55 5.96C25.55 5.96 25.55 5.96 25.54 5.96C25.52 5.96 25.5 5.96 25.48 5.96C25.47 5.96 25.47 5.96 25.46 5.96C25.44 5.96 25.42 5.97 25.4 5.97C22.59 6.81 20.24 6.47 18.42 4.93C17.04 3.77 16.47 2.33 16.47 2.32C16.46 2.3 16.45 2.28 16.44 2.26C16.43 2.24 16.42 2.23 16.41 2.21L16.4 2.2C16.39 2.18 16.37 2.17 16.36 2.15C16.35 2.14 16.33 2.12 16.32 2.11L16.31 2.1C16.28 2.08 16.24 2.05 16.2 2.04H16.19C16.17 2.03 16.15 2.03 16.13 2.02C16.09 2.01 16.07 2 16.05 2C16.05 2 16.05 2 16.04 2H16.03C16.02 2 16.02 2 16.01 2C16 2 15.99 2 15.98 2C15.97 2 15.97 2 15.96 2C15.94 2 15.92 2.01 15.9 2.01H15.89C15.87 2.01 15.86 2.02 15.84 2.03C15.84 2.03 15.83 2.03 15.83 2.04C15.81 2.05 15.79 2.06 15.77 2.07C15.77 2.07 15.77 2.07 15.76 2.07C15.74 2.08 15.73 2.09 15.71 2.1L15.7 2.11C15.68 2.12 15.67 2.14 15.65 2.15C15.64 2.16 15.62 2.18 15.61 2.19L15.6 2.2C15.59 2.22 15.58 2.24 15.57 2.25C14.18 4.83 12.27 6.25 9.89999 6.45C8.09999 6.63 6.67999 6 6.66999 6C6.66999 6 6.66999 6 6.65999 6C6.63999 5.99 6.61999 5.98 6.59999 5.97C6.59999 5.97 6.59999 5.97 6.58999 5.97C6.56999 5.97 6.54999 5.96 6.53999 5.96C6.52999 5.96 6.52999 5.96 6.51999 5.96C6.49999 5.96 6.47999 5.96 6.45999 5.96H6.44999C6.42999 5.96 6.40999 5.96 6.39999 5.96C6.38999 5.96 6.38999 5.96 6.37999 5.96C6.33999 5.97 6.29999 5.98 6.25999 6C6.25999 6 6.24999 6 6.24999 6.01C6.22999 6.01 6.20999 6.02 6.19999 6.03C6.16999 6.05 6.15999 6.06 6.13999 6.07C6.13999 6.07 6.13999 6.07 6.12999 6.07C6.12999 6.07 6.12999 6.07 6.11999 6.08C6.11999 6.09 6.11999 6.1 6.10999 6.1C6.09999 6.11 6.09999 6.12 6.08999 6.12L6.07999 6.13C6.06999 6.15 6.04999 6.17 6.03999 6.19C6.03999 6.19 6.03999 6.2 6.02999 6.2C6.02999 6.21 6.01999 6.23 6.00999 6.24C6.00999 6.24 6.00999 6.25 5.99999 6.25C5.99999 6.27 5.98999 6.29 5.97999 6.32C5.97999 6.34 5.96999 6.36 5.96999 6.38C5.96999 6.39 5.96999 6.39 5.96999 6.4C5.96999 6.42 5.96999 6.44 5.96999 6.46C5.96999 6.48 5.96999 6.5 5.96999 6.52V6.53C5.96999 6.55 5.97999 6.57 5.97999 6.59C6.81999 9.4 6.47999 11.75 4.93999 13.57C3.77999 14.95 2.34999 15.51 2.31999 15.52C2.29999 15.53 2.27999 15.54 2.25999 15.55C2.25999 15.55 2.25999 15.55 2.24999 15.55C2.22999 15.56 2.21999 15.57 2.19999 15.58L2.18999 15.59C2.16999 15.6 2.15999 15.62 2.13999 15.63C2.13999 15.63 2.13999 15.63 2.12999 15.64C2.11999 15.65 2.10999 15.67 2.08999 15.68L2.07999 15.69C2.05999 15.72 2.03999 15.76 2.01999 15.8V15.81C2.00999 15.83 2.00999 15.85 1.99999 15.87C1.99999 15.89 1.98999 15.91 1.98999 15.93C1.98999 15.93 1.98999 15.93 1.98999 15.94V15.95C1.98999 15.96 1.98999 15.97 1.98999 15.97C1.98999 15.98 1.98999 15.99 1.98999 16V16.01C1.98999 16.03 1.99999 16.05 1.99999 16.07V16.08C1.99999 16.1 2.00999 16.12 2.01999 16.13V16.14C2.02999 16.16 2.03999 16.18 2.04999 16.2C2.05999 16.22 2.06999 16.23 2.07999 16.25L2.08999 16.26C2.09999 16.28 2.11999 16.29 2.12999 16.31C2.13999 16.32 2.15999 16.34 2.17999 16.35L2.18999 16.36C2.20999 16.37 2.22999 16.38 2.24999 16.4C4.82999 17.79 6.24999 19.7 6.44999 22.07C6.62999 23.91 6.00999 25.33 6.00999 25.34C6.00999 25.34 6.00999 25.34 6.00999 25.35C5.99999 25.37 5.98999 25.39 5.98999 25.41C5.98999 25.41 5.98999 25.41 5.98999 25.42C5.97999 25.44 5.97999 25.46 5.97999 25.48C5.97999 25.49 5.97999 25.49 5.97999 25.5C5.97999 25.52 5.97999 25.54 5.97999 25.56C5.97999 25.56 5.97999 25.56 5.97999 25.57C5.97999 25.59 5.97999 25.61 5.97999 25.63V25.64C5.98999 25.68 5.99999 25.72 6.01999 25.76C6.01999 25.76 6.01999 25.77 6.02999 25.77C6.03999 25.79 6.04999 25.81 6.05999 25.82C6.06999 25.84 6.08999 25.86 6.09999 25.87C6.09999 25.87 6.09999 25.87 6.09999 25.88C6.09999 25.88 6.09999 25.88 6.10999 25.89C6.11999 25.9 6.11999 25.9 6.12999 25.91C6.13999 25.92 6.13999 25.92 6.14999 25.93L6.15999 25.94C6.17999 25.95 6.18999 25.97 6.20999 25.98C6.20999 25.98 6.21999 25.98 6.21999 25.99C6.23999 26 6.24999 26.01 6.26999 26.02C6.26999 26.02 6.27999 26.02 6.27999 26.03C6.29999 26.04 6.31999 26.05 6.33999 26.05C6.33999 26.05 6.33999 26.05 6.34999 26.05C6.36999 26.06 6.38999 26.06 6.40999 26.06C6.41999 26.06 6.41999 26.06 6.42999 26.06C6.44999 26.06 6.46999 26.06 6.48999 26.06C6.50999 26.06 6.52999 26.06 6.54999 26.06C6.55999 26.06 6.55999 26.06 6.55999 26.06C6.57999 26.06 6.59999 26.05 6.61999 26.05C9.42999 25.2 11.78 25.55 13.6 27.09C14.98 28.25 15.55 29.69 15.55 29.7C15.56 29.72 15.57 29.74 15.58 29.76C15.59 29.78 15.6 29.79 15.61 29.81L15.62 29.82C15.63 29.84 15.65 29.85 15.66 29.87C15.67 29.88 15.69 29.9 15.7 29.91L15.71 29.92C15.74 29.94 15.78 29.97 15.82 29.98H15.83C15.85 29.99 15.87 29.99 15.89 30C15.91 30 15.93 30.01 15.95 30.01C15.95 30.01 15.95 30.01 15.96 30.01C15.97 30.01 15.98 30.01 15.99 30.01C16.01 30.01 16.03 30.01 16.05 30.01C16.06 30.01 16.06 30.01 16.07 30.01C16.09 30.01 16.1 30 16.12 30H16.13C16.17 29.99 16.21 29.97 16.24 29.95L16.25 29.94C16.26 29.93 16.28 29.92 16.29 29.91L16.3 29.9C16.32 29.89 16.33 29.87 16.34 29.86L16.35 29.85C16.36 29.84 16.37 29.83 16.38 29.81L16.39 29.8C16.4 29.78 16.41 29.77 16.42 29.75C17.81 27.17 19.72 25.75 22.09 25.55C23.89 25.39 25.31 26.01 25.32 26.02C25.34 26.03 25.36 26.04 25.38 26.04C25.38 26.04 25.38 26.04 25.39 26.04C25.41 26.05 25.43 26.05 25.45 26.05C25.46 26.05 25.46 26.05 25.47 26.05C25.49 26.05 25.51 26.05 25.53 26.05C25.53 26.05 25.53 26.05 25.54 26.05C25.56 26.05 25.58 26.05 25.6 26.05C25.61 26.05 25.61 26.05 25.62 26.05C25.66 26.04 25.7 26.03 25.74 26.01C25.74 26.01 25.75 26.01 25.75 26C25.77 25.99 25.79 25.98 25.8 25.97C25.82 25.96 25.84 25.94 25.85 25.93C25.85 25.93 25.85 25.93 25.86 25.93C25.86 25.93 25.86 25.93 25.87 25.92C25.88 25.91 25.88 25.91 25.89 25.9C25.9 25.89 25.9 25.89 25.91 25.88L25.92 25.87C25.93 25.85 25.95 25.84 25.96 25.82C25.96 25.82 25.96 25.81 25.97 25.81C25.98 25.79 25.99 25.78 26 25.76C26 25.76 26 25.75 26.01 25.75C26.02 25.73 26.03 25.71 26.03 25.69C26.04 25.67 26.04 25.65 26.04 25.63C26.04 25.62 26.04 25.62 26.04 25.61C26.04 25.59 26.04 25.57 26.04 25.55C26.04 25.53 26.04 25.51 26.04 25.49V25.48C26.04 25.46 26.03 25.44 26.03 25.42C25.19 22.61 25.53 20.26 27.07 18.44C28.23 17.06 29.67 16.49 29.68 16.49C29.7 16.48 29.72 16.47 29.74 16.46C29.74 16.46 29.74 16.46 29.75 16.46C29.77 16.45 29.78 16.44 29.8 16.43L29.81 16.42C29.83 16.41 29.84 16.39 29.86 16.38C29.87 16.37 29.89 16.35 29.9 16.34C29.91 16.3 29.91 16.3 29.92 16.29ZM27.79 15.5H23.64C20.8 13.9 21.56 11.45 21.74 10.98L24.6 8.12C24.52 8.65 24.49 9.27 24.54 9.93C24.75 12.54 26.22 14.32 27.79 15.5ZM11.49 19.36C11.42 18.54 11.1 17.46 10.08 16.5H14.81L11.51 19.8C11.51 19.66 11.5 19.51 11.49 19.36ZM16.51 10.13C16.61 10.23 16.72 10.33 16.83 10.43C17.43 10.94 18.36 11.45 19.68 11.45C19.74 11.45 19.79 11.45 19.85 11.45L16.51 14.79V10.13V10.13ZM15.51 14.79L12.21 11.49C12.35 11.49 12.5 11.49 12.65 11.48C13.47 11.41 14.55 11.09 15.51 10.07V14.79V14.79ZM14.8 15.5H10.14C10.24 15.4 10.34 15.29 10.44 15.18C10.97 14.55 11.51 13.57 11.46 12.16L14.8 15.5ZM15.51 17.21V21.88C15.41 21.78 15.3 21.68 15.19 21.58C14.59 21.07 13.66 20.56 12.34 20.56C12.28 20.56 12.23 20.56 12.17 20.56L15.51 17.21ZM16.51 17.21L19.81 20.51C19.67 20.51 19.52 20.51 19.37 20.52C18.55 20.59 17.47 20.91 16.51 21.93V17.21ZM17.22 16.5H21.89C21.79 16.6 21.69 16.71 21.59 16.82C21.06 17.45 20.52 18.43 20.57 19.84L17.22 16.5ZM17.22 15.5L20.52 12.2C20.52 12.34 20.52 12.49 20.53 12.64C20.6 13.46 20.92 14.54 21.94 15.5H17.22V15.5ZM17.75 5.67C19.74 7.37 22.04 7.59 23.99 7.31L21.05 10.25C17.91 11.13 16.72 8.86 16.51 8.4V4.35C16.83 4.78 17.24 5.24 17.75 5.67ZM9.93999 7.47C12.55 7.26 14.33 5.79 15.51 4.22V8.37C13.91 11.21 11.46 10.45 10.99 10.27L8.12999 7.41C8.65999 7.48 9.26999 7.52 9.93999 7.47ZM5.67999 14.26C7.37999 12.27 7.59999 9.97 7.31999 8.02L10.26 10.96C11.14 14.09 8.86999 15.29 8.40999 15.5H4.35999C4.78999 15.18 5.24999 14.77 5.67999 14.26ZM4.22999 16.5H8.37999C11.22 18.1 10.46 20.55 10.28 21.02L7.41999 23.88C7.49999 23.35 7.52999 22.73 7.47999 22.07C7.26999 19.46 5.79999 17.68 4.22999 16.5ZM14.27 26.33C12.73 25.02 11 24.59 9.39999 24.59C8.92999 24.59 8.46999 24.63 8.02999 24.69L10.97 21.75C14.11 20.87 15.3 23.14 15.51 23.6V27.65C15.19 27.22 14.78 26.76 14.27 26.33ZM22.08 24.53C19.47 24.74 17.69 26.21 16.51 27.78V23.63C18.11 20.79 20.56 21.55 21.03 21.73L23.89 24.59C23.36 24.52 22.75 24.48 22.08 24.53ZM26.34 17.74C24.64 19.73 24.42 22.03 24.7 23.98L21.76 21.04C20.88 17.9 23.15 16.71 23.61 16.5H27.66C27.23 16.82 26.77 17.23 26.34 17.74Z",
  fill: "url(#paint0_radial_28327_6675)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f_28327_6675)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.98999 6.78125L15.5369 15.3438",
  stroke: "#C1BAC8",
  strokeWidth: 0.4,
  strokeLinecap: "round"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_f_28327_6675)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.1697 3.08936L16.1586 15.1875",
  stroke: "#C1BAC8",
  strokeWidth: 0.4,
  strokeLinecap: "round"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_f_28327_6675)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.1752 16.9509L16.1642 29.0491",
  stroke: "#C1BAC8",
  strokeWidth: 0.4,
  strokeLinecap: "round"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_f_28327_6675)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.6775 16.5287L25.2244 25.0912",
  stroke: "#C1BAC8",
  strokeWidth: 0.4,
  strokeLinecap: "round"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter5_f_28327_6675)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.33972 15.88H15.4275",
  stroke: "#C1B7CB",
  strokeWidth: 0.4,
  strokeLinecap: "round"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter6_f_28327_6675)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.6775 15.88H28.7653",
  stroke: "#C1B7CB",
  strokeWidth: 0.4,
  strokeLinecap: "round"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter7_f_28327_6675)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.677 15.3438L25.2243 6.79641",
  stroke: "#C1B7CB",
  strokeWidth: 0.4,
  strokeLinecap: "round"
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter8_f_28327_6675)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.98999 25.0912L15.5373 16.5438",
  stroke: "#C1B7CB",
  strokeWidth: 0.4,
  strokeLinecap: "round"
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter9_f_28327_6675)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.80249 16.0156C5.13062 17.1875 8.15249 20.3812 6.67749 25.2812",
  stroke: "#C1B7CB",
  strokeWidth: 0.4,
  strokeLinecap: "round"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter10_f_28327_6675)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.83374 25.375C8.69832 24.7187 13.4587 24.5437 15.8337 28.9687",
  stroke: "#C1B7CB",
  strokeWidth: 0.4,
  strokeLinecap: "round"
}));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter11_f_28327_6675)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.615 28.5937C17.3962 27.0312 20.165 24.1687 24.99 25.2187",
  stroke: "#C1B7CB",
  strokeWidth: 0.4,
  strokeLinecap: "round"
}));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter12_f_28327_6675)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.7712 16.25C27.1358 17.1146 24.1306 20.3531 25.3806 25.2031",
  stroke: "url(#paint1_linear_28327_6675)",
  strokeWidth: 0.4,
  strokeLinecap: "round"
}));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter13_f_28327_6675)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.2087 6.9375C24.7191 8.77083 24.7087 13.0156 28.9587 15.7344",
  stroke: "#C1B7CB",
  strokeWidth: 0.4,
  strokeLinecap: "round"
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter14_f_28327_6675)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.0212 2.85938C16.9431 4.48438 19.6025 7.925 25.0525 6.75",
  stroke: "url(#paint2_linear_28327_6675)",
  strokeWidth: 0.4,
  strokeLinecap: "round"
}));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter15_f_28327_6675)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.11499 6.75C8.91187 7.39062 13.49 7.20312 15.7087 3.1875",
  stroke: "url(#paint3_linear_28327_6675)",
  strokeWidth: 0.4,
  strokeLinecap: "round"
}));

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M29.92 16.29C29.94 16.26 29.97 16.22 29.98 16.18V16.17C29.99 16.15 29.99 16.13 30 16.11C30 16.09 30.01 16.07 30.01 16.04C30.01 16.04 30.01 16.04 30.01 16.03V16.02C30.01 16.01 30.01 16 30.01 16C30.01 15.99 30.01 15.98 30.01 15.97V15.96C30.01 15.94 30 15.92 30 15.9V15.89C30 15.87 29.99 15.85 29.98 15.84V15.83C29.97 15.81 29.96 15.79 29.95 15.77C29.94 15.75 29.93 15.74 29.92 15.72L29.91 15.71C29.9 15.69 29.88 15.68 29.87 15.66C29.86 15.65 29.84 15.63 29.82 15.62L29.81 15.61C29.79 15.6 29.77 15.59 29.75 15.57C27.17 14.18 25.75 12.27 25.55 9.9C25.39 8.09 26.01 6.67 26.01 6.66C26.01 6.66 26.01 6.66 26.01 6.65C26.02 6.63 26.03 6.61 26.03 6.59C26.03 6.59 26.03 6.59 26.03 6.58C26.04 6.56 26.04 6.54 26.04 6.52C26.04 6.51 26.04 6.51 26.04 6.5C26.04 6.48 26.04 6.46 26.04 6.44C26.04 6.44 26.04 6.44 26.04 6.43C26.04 6.41 26.04 6.39 26.04 6.37V6.36C26.04 6.33 26.03 6.29 26.01 6.25C26.01 6.25 26.01 6.24 26 6.24C25.99 6.22 25.98 6.2 25.97 6.19C25.96 6.17 25.94 6.15 25.93 6.14C25.93 6.14 25.93 6.14 25.93 6.13C25.93 6.13 25.93 6.13 25.92 6.12C25.91 6.11 25.91 6.11 25.9 6.1C25.89 6.09 25.89 6.09 25.88 6.08L25.87 6.07C25.85 6.06 25.84 6.04 25.82 6.03C25.82 6.03 25.81 6.03 25.81 6.02C25.8 6.02 25.78 6.01 25.77 6C25.77 6 25.76 6 25.76 5.99C25.74 5.98 25.72 5.97 25.7 5.97C25.7 5.97 25.7 5.97 25.69 5.97C25.67 5.96 25.65 5.96 25.63 5.96C25.62 5.96 25.62 5.96 25.61 5.96C25.59 5.96 25.57 5.96 25.55 5.96C25.55 5.96 25.55 5.96 25.54 5.96C25.52 5.96 25.5 5.96 25.48 5.96C25.47 5.96 25.47 5.96 25.46 5.96C25.44 5.96 25.42 5.97 25.4 5.97C22.59 6.81 20.24 6.47 18.42 4.93C17.04 3.77 16.47 2.33 16.47 2.32C16.46 2.3 16.45 2.28 16.44 2.26C16.43 2.24 16.42 2.23 16.41 2.21L16.4 2.2C16.39 2.18 16.37 2.17 16.36 2.15C16.35 2.14 16.33 2.12 16.32 2.11L16.31 2.1C16.28 2.08 16.24 2.05 16.2 2.04H16.19C16.17 2.03 16.15 2.03 16.13 2.02C16.09 2.01 16.07 2 16.05 2C16.05 2 16.05 2 16.04 2H16.03C16.02 2 16.02 2 16.01 2C16 2 15.99 2 15.98 2C15.97 2 15.97 2 15.96 2C15.94 2 15.92 2.01 15.9 2.01H15.89C15.87 2.01 15.86 2.02 15.84 2.03C15.84 2.03 15.83 2.03 15.83 2.04C15.81 2.05 15.79 2.06 15.77 2.07C15.77 2.07 15.77 2.07 15.76 2.07C15.74 2.08 15.73 2.09 15.71 2.1L15.7 2.11C15.68 2.12 15.67 2.14 15.65 2.15C15.64 2.16 15.62 2.18 15.61 2.19L15.6 2.2C15.59 2.22 15.58 2.24 15.57 2.25C14.18 4.83 12.27 6.25 9.89999 6.45C8.09999 6.63 6.67999 6 6.66999 6C6.66999 6 6.66999 6 6.65999 6C6.63999 5.99 6.61999 5.98 6.59999 5.97C6.59999 5.97 6.59999 5.97 6.58999 5.97C6.56999 5.97 6.54999 5.96 6.53999 5.96C6.52999 5.96 6.52999 5.96 6.51999 5.96C6.49999 5.96 6.47999 5.96 6.45999 5.96H6.44999C6.42999 5.96 6.40999 5.96 6.39999 5.96C6.38999 5.96 6.38999 5.96 6.37999 5.96C6.33999 5.97 6.29999 5.98 6.25999 6C6.25999 6 6.24999 6 6.24999 6.01C6.22999 6.01 6.20999 6.02 6.19999 6.03C6.16999 6.05 6.15999 6.06 6.13999 6.07C6.13999 6.07 6.13999 6.07 6.12999 6.07C6.12999 6.07 6.12999 6.07 6.11999 6.08C6.11999 6.09 6.11999 6.1 6.10999 6.1C6.09999 6.11 6.09999 6.12 6.08999 6.12L6.07999 6.13C6.06999 6.15 6.04999 6.17 6.03999 6.19C6.03999 6.19 6.03999 6.2 6.02999 6.2C6.02999 6.21 6.01999 6.23 6.00999 6.24C6.00999 6.24 6.00999 6.25 5.99999 6.25C5.99999 6.27 5.98999 6.29 5.97999 6.32C5.97999 6.34 5.96999 6.36 5.96999 6.38C5.96999 6.39 5.96999 6.39 5.96999 6.4C5.96999 6.42 5.96999 6.44 5.96999 6.46C5.96999 6.48 5.96999 6.5 5.96999 6.52V6.53C5.96999 6.55 5.97999 6.57 5.97999 6.59C6.81999 9.4 6.47999 11.75 4.93999 13.57C3.77999 14.95 2.34999 15.51 2.31999 15.52C2.29999 15.53 2.27999 15.54 2.25999 15.55C2.25999 15.55 2.25999 15.55 2.24999 15.55C2.22999 15.56 2.21999 15.57 2.19999 15.58L2.18999 15.59C2.16999 15.6 2.15999 15.62 2.13999 15.63C2.13999 15.63 2.13999 15.63 2.12999 15.64C2.11999 15.65 2.10999 15.67 2.08999 15.68L2.07999 15.69C2.05999 15.72 2.03999 15.76 2.01999 15.8V15.81C2.00999 15.83 2.00999 15.85 1.99999 15.87C1.99999 15.89 1.98999 15.91 1.98999 15.93C1.98999 15.93 1.98999 15.93 1.98999 15.94V15.95C1.98999 15.96 1.98999 15.97 1.98999 15.97C1.98999 15.98 1.98999 15.99 1.98999 16V16.01C1.98999 16.03 1.99999 16.05 1.99999 16.07V16.08C1.99999 16.1 2.00999 16.12 2.01999 16.13V16.14C2.02999 16.16 2.03999 16.18 2.04999 16.2C2.05999 16.22 2.06999 16.23 2.07999 16.25L2.08999 16.26C2.09999 16.28 2.11999 16.29 2.12999 16.31C2.13999 16.32 2.15999 16.34 2.17999 16.35L2.18999 16.36C2.20999 16.37 2.22999 16.38 2.24999 16.4C4.82999 17.79 6.24999 19.7 6.44999 22.07C6.62999 23.91 6.00999 25.33 6.00999 25.34C6.00999 25.34 6.00999 25.34 6.00999 25.35C5.99999 25.37 5.98999 25.39 5.98999 25.41C5.98999 25.41 5.98999 25.41 5.98999 25.42C5.97999 25.44 5.97999 25.46 5.97999 25.48C5.97999 25.49 5.97999 25.49 5.97999 25.5C5.97999 25.52 5.97999 25.54 5.97999 25.56C5.97999 25.56 5.97999 25.56 5.97999 25.57C5.97999 25.59 5.97999 25.61 5.97999 25.63V25.64C5.98999 25.68 5.99999 25.72 6.01999 25.76C6.01999 25.76 6.01999 25.77 6.02999 25.77C6.03999 25.79 6.04999 25.81 6.05999 25.82C6.06999 25.84 6.08999 25.86 6.09999 25.87C6.09999 25.87 6.09999 25.87 6.09999 25.88C6.09999 25.88 6.09999 25.88 6.10999 25.89C6.11999 25.9 6.11999 25.9 6.12999 25.91C6.13999 25.92 6.13999 25.92 6.14999 25.93L6.15999 25.94C6.17999 25.95 6.18999 25.97 6.20999 25.98C6.20999 25.98 6.21999 25.98 6.21999 25.99C6.23999 26 6.24999 26.01 6.26999 26.02C6.26999 26.02 6.27999 26.02 6.27999 26.03C6.29999 26.04 6.31999 26.05 6.33999 26.05C6.33999 26.05 6.33999 26.05 6.34999 26.05C6.36999 26.06 6.38999 26.06 6.40999 26.06C6.41999 26.06 6.41999 26.06 6.42999 26.06C6.44999 26.06 6.46999 26.06 6.48999 26.06C6.50999 26.06 6.52999 26.06 6.54999 26.06C6.55999 26.06 6.55999 26.06 6.55999 26.06C6.57999 26.06 6.59999 26.05 6.61999 26.05C9.42999 25.2 11.78 25.55 13.6 27.09C14.98 28.25 15.55 29.69 15.55 29.7C15.56 29.72 15.57 29.74 15.58 29.76C15.59 29.78 15.6 29.79 15.61 29.81L15.62 29.82C15.63 29.84 15.65 29.85 15.66 29.87C15.67 29.88 15.69 29.9 15.7 29.91L15.71 29.92C15.74 29.94 15.78 29.97 15.82 29.98H15.83C15.85 29.99 15.87 29.99 15.89 30C15.91 30 15.93 30.01 15.95 30.01C15.95 30.01 15.95 30.01 15.96 30.01C15.97 30.01 15.98 30.01 15.99 30.01C16.01 30.01 16.03 30.01 16.05 30.01C16.06 30.01 16.06 30.01 16.07 30.01C16.09 30.01 16.1 30 16.12 30H16.13C16.17 29.99 16.21 29.97 16.24 29.95L16.25 29.94C16.26 29.93 16.28 29.92 16.29 29.91L16.3 29.9C16.32 29.89 16.33 29.87 16.34 29.86L16.35 29.85C16.36 29.84 16.37 29.83 16.38 29.81L16.39 29.8C16.4 29.78 16.41 29.77 16.42 29.75C17.81 27.17 19.72 25.75 22.09 25.55C23.89 25.39 25.31 26.01 25.32 26.02C25.34 26.03 25.36 26.04 25.38 26.04C25.38 26.04 25.38 26.04 25.39 26.04C25.41 26.05 25.43 26.05 25.45 26.05C25.46 26.05 25.46 26.05 25.47 26.05C25.49 26.05 25.51 26.05 25.53 26.05C25.53 26.05 25.53 26.05 25.54 26.05C25.56 26.05 25.58 26.05 25.6 26.05C25.61 26.05 25.61 26.05 25.62 26.05C25.66 26.04 25.7 26.03 25.74 26.01C25.74 26.01 25.75 26.01 25.75 26C25.77 25.99 25.79 25.98 25.8 25.97C25.82 25.96 25.84 25.94 25.85 25.93C25.85 25.93 25.85 25.93 25.86 25.93C25.86 25.93 25.86 25.93 25.87 25.92C25.88 25.91 25.88 25.91 25.89 25.9C25.9 25.89 25.9 25.89 25.91 25.88L25.92 25.87C25.93 25.85 25.95 25.84 25.96 25.82C25.96 25.82 25.96 25.81 25.97 25.81C25.98 25.79 25.99 25.78 26 25.76C26 25.76 26 25.75 26.01 25.75C26.02 25.73 26.03 25.71 26.03 25.69C26.04 25.67 26.04 25.65 26.04 25.63C26.04 25.62 26.04 25.62 26.04 25.61C26.04 25.59 26.04 25.57 26.04 25.55C26.04 25.53 26.04 25.51 26.04 25.49V25.48C26.04 25.46 26.03 25.44 26.03 25.42C25.19 22.61 25.53 20.26 27.07 18.44C28.23 17.06 29.67 16.49 29.68 16.49C29.7 16.48 29.72 16.47 29.74 16.46C29.74 16.46 29.74 16.46 29.75 16.46C29.77 16.45 29.78 16.44 29.8 16.43L29.81 16.42C29.83 16.41 29.84 16.39 29.86 16.38C29.87 16.37 29.89 16.35 29.9 16.34C29.91 16.3 29.91 16.3 29.92 16.29ZM27.79 15.5H23.64C20.8 13.9 21.56 11.45 21.74 10.98L24.6 8.12C24.52 8.65 24.49 9.27 24.54 9.93C24.75 12.54 26.22 14.32 27.79 15.5ZM11.49 19.36C11.42 18.54 11.1 17.46 10.08 16.5H14.81L11.51 19.8C11.51 19.66 11.5 19.51 11.49 19.36ZM16.51 10.13C16.61 10.23 16.72 10.33 16.83 10.43C17.43 10.94 18.36 11.45 19.68 11.45C19.74 11.45 19.79 11.45 19.85 11.45L16.51 14.79V10.13V10.13ZM15.51 14.79L12.21 11.49C12.35 11.49 12.5 11.49 12.65 11.48C13.47 11.41 14.55 11.09 15.51 10.07V14.79V14.79ZM14.8 15.5H10.14C10.24 15.4 10.34 15.29 10.44 15.18C10.97 14.55 11.51 13.57 11.46 12.16L14.8 15.5ZM15.51 17.21V21.88C15.41 21.78 15.3 21.68 15.19 21.58C14.59 21.07 13.66 20.56 12.34 20.56C12.28 20.56 12.23 20.56 12.17 20.56L15.51 17.21ZM16.51 17.21L19.81 20.51C19.67 20.51 19.52 20.51 19.37 20.52C18.55 20.59 17.47 20.91 16.51 21.93V17.21ZM17.22 16.5H21.89C21.79 16.6 21.69 16.71 21.59 16.82C21.06 17.45 20.52 18.43 20.57 19.84L17.22 16.5ZM17.22 15.5L20.52 12.2C20.52 12.34 20.52 12.49 20.53 12.64C20.6 13.46 20.92 14.54 21.94 15.5H17.22V15.5ZM17.75 5.67C19.74 7.37 22.04 7.59 23.99 7.31L21.05 10.25C17.91 11.13 16.72 8.86 16.51 8.4V4.35C16.83 4.78 17.24 5.24 17.75 5.67ZM9.93999 7.47C12.55 7.26 14.33 5.79 15.51 4.22V8.37C13.91 11.21 11.46 10.45 10.99 10.27L8.12999 7.41C8.65999 7.48 9.26999 7.52 9.93999 7.47ZM5.67999 14.26C7.37999 12.27 7.59999 9.97 7.31999 8.02L10.26 10.96C11.14 14.09 8.86999 15.29 8.40999 15.5H4.35999C4.78999 15.18 5.24999 14.77 5.67999 14.26ZM4.22999 16.5H8.37999C11.22 18.1 10.46 20.55 10.28 21.02L7.41999 23.88C7.49999 23.35 7.52999 22.73 7.47999 22.07C7.26999 19.46 5.79999 17.68 4.22999 16.5ZM14.27 26.33C12.73 25.02 11 24.59 9.39999 24.59C8.92999 24.59 8.46999 24.63 8.02999 24.69L10.97 21.75C14.11 20.87 15.3 23.14 15.51 23.6V27.65C15.19 27.22 14.78 26.76 14.27 26.33ZM22.08 24.53C19.47 24.74 17.69 26.21 16.51 27.78V23.63C18.11 20.79 20.56 21.55 21.03 21.73L23.89 24.59C23.36 24.52 22.75 24.48 22.08 24.53ZM26.34 17.74C24.64 19.73 24.42 22.03 24.7 23.98L21.76 21.04C20.88 17.9 23.15 16.71 23.61 16.5H27.66C27.23 16.82 26.77 17.23 26.34 17.74Z",
  fill: "url(#paint4_radial_28327_6675)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M29.92 16.29C29.94 16.26 29.97 16.22 29.98 16.18V16.17C29.99 16.15 29.99 16.13 30 16.11C30 16.09 30.01 16.07 30.01 16.04C30.01 16.04 30.01 16.04 30.01 16.03V16.02C30.01 16.01 30.01 16 30.01 16C30.01 15.99 30.01 15.98 30.01 15.97V15.96C30.01 15.94 30 15.92 30 15.9V15.89C30 15.87 29.99 15.85 29.98 15.84V15.83C29.97 15.81 29.96 15.79 29.95 15.77C29.94 15.75 29.93 15.74 29.92 15.72L29.91 15.71C29.9 15.69 29.88 15.68 29.87 15.66C29.86 15.65 29.84 15.63 29.82 15.62L29.81 15.61C29.79 15.6 29.77 15.59 29.75 15.57C27.17 14.18 25.75 12.27 25.55 9.9C25.39 8.09 26.01 6.67 26.01 6.66C26.01 6.66 26.01 6.66 26.01 6.65C26.02 6.63 26.03 6.61 26.03 6.59C26.03 6.59 26.03 6.59 26.03 6.58C26.04 6.56 26.04 6.54 26.04 6.52C26.04 6.51 26.04 6.51 26.04 6.5C26.04 6.48 26.04 6.46 26.04 6.44C26.04 6.44 26.04 6.44 26.04 6.43C26.04 6.41 26.04 6.39 26.04 6.37V6.36C26.04 6.33 26.03 6.29 26.01 6.25C26.01 6.25 26.01 6.24 26 6.24C25.99 6.22 25.98 6.2 25.97 6.19C25.96 6.17 25.94 6.15 25.93 6.14C25.93 6.14 25.93 6.14 25.93 6.13C25.93 6.13 25.93 6.13 25.92 6.12C25.91 6.11 25.91 6.11 25.9 6.1C25.89 6.09 25.89 6.09 25.88 6.08L25.87 6.07C25.85 6.06 25.84 6.04 25.82 6.03C25.82 6.03 25.81 6.03 25.81 6.02C25.8 6.02 25.78 6.01 25.77 6C25.77 6 25.76 6 25.76 5.99C25.74 5.98 25.72 5.97 25.7 5.97C25.7 5.97 25.7 5.97 25.69 5.97C25.67 5.96 25.65 5.96 25.63 5.96C25.62 5.96 25.62 5.96 25.61 5.96C25.59 5.96 25.57 5.96 25.55 5.96C25.55 5.96 25.55 5.96 25.54 5.96C25.52 5.96 25.5 5.96 25.48 5.96C25.47 5.96 25.47 5.96 25.46 5.96C25.44 5.96 25.42 5.97 25.4 5.97C22.59 6.81 20.24 6.47 18.42 4.93C17.04 3.77 16.47 2.33 16.47 2.32C16.46 2.3 16.45 2.28 16.44 2.26C16.43 2.24 16.42 2.23 16.41 2.21L16.4 2.2C16.39 2.18 16.37 2.17 16.36 2.15C16.35 2.14 16.33 2.12 16.32 2.11L16.31 2.1C16.28 2.08 16.24 2.05 16.2 2.04H16.19C16.17 2.03 16.15 2.03 16.13 2.02C16.09 2.01 16.07 2 16.05 2C16.05 2 16.05 2 16.04 2H16.03C16.02 2 16.02 2 16.01 2C16 2 15.99 2 15.98 2C15.97 2 15.97 2 15.96 2C15.94 2 15.92 2.01 15.9 2.01H15.89C15.87 2.01 15.86 2.02 15.84 2.03C15.84 2.03 15.83 2.03 15.83 2.04C15.81 2.05 15.79 2.06 15.77 2.07C15.77 2.07 15.77 2.07 15.76 2.07C15.74 2.08 15.73 2.09 15.71 2.1L15.7 2.11C15.68 2.12 15.67 2.14 15.65 2.15C15.64 2.16 15.62 2.18 15.61 2.19L15.6 2.2C15.59 2.22 15.58 2.24 15.57 2.25C14.18 4.83 12.27 6.25 9.89999 6.45C8.09999 6.63 6.67999 6 6.66999 6C6.66999 6 6.66999 6 6.65999 6C6.63999 5.99 6.61999 5.98 6.59999 5.97C6.59999 5.97 6.59999 5.97 6.58999 5.97C6.56999 5.97 6.54999 5.96 6.53999 5.96C6.52999 5.96 6.52999 5.96 6.51999 5.96C6.49999 5.96 6.47999 5.96 6.45999 5.96H6.44999C6.42999 5.96 6.40999 5.96 6.39999 5.96C6.38999 5.96 6.38999 5.96 6.37999 5.96C6.33999 5.97 6.29999 5.98 6.25999 6C6.25999 6 6.24999 6 6.24999 6.01C6.22999 6.01 6.20999 6.02 6.19999 6.03C6.16999 6.05 6.15999 6.06 6.13999 6.07C6.13999 6.07 6.13999 6.07 6.12999 6.07C6.12999 6.07 6.12999 6.07 6.11999 6.08C6.11999 6.09 6.11999 6.1 6.10999 6.1C6.09999 6.11 6.09999 6.12 6.08999 6.12L6.07999 6.13C6.06999 6.15 6.04999 6.17 6.03999 6.19C6.03999 6.19 6.03999 6.2 6.02999 6.2C6.02999 6.21 6.01999 6.23 6.00999 6.24C6.00999 6.24 6.00999 6.25 5.99999 6.25C5.99999 6.27 5.98999 6.29 5.97999 6.32C5.97999 6.34 5.96999 6.36 5.96999 6.38C5.96999 6.39 5.96999 6.39 5.96999 6.4C5.96999 6.42 5.96999 6.44 5.96999 6.46C5.96999 6.48 5.96999 6.5 5.96999 6.52V6.53C5.96999 6.55 5.97999 6.57 5.97999 6.59C6.81999 9.4 6.47999 11.75 4.93999 13.57C3.77999 14.95 2.34999 15.51 2.31999 15.52C2.29999 15.53 2.27999 15.54 2.25999 15.55C2.25999 15.55 2.25999 15.55 2.24999 15.55C2.22999 15.56 2.21999 15.57 2.19999 15.58L2.18999 15.59C2.16999 15.6 2.15999 15.62 2.13999 15.63C2.13999 15.63 2.13999 15.63 2.12999 15.64C2.11999 15.65 2.10999 15.67 2.08999 15.68L2.07999 15.69C2.05999 15.72 2.03999 15.76 2.01999 15.8V15.81C2.00999 15.83 2.00999 15.85 1.99999 15.87C1.99999 15.89 1.98999 15.91 1.98999 15.93C1.98999 15.93 1.98999 15.93 1.98999 15.94V15.95C1.98999 15.96 1.98999 15.97 1.98999 15.97C1.98999 15.98 1.98999 15.99 1.98999 16V16.01C1.98999 16.03 1.99999 16.05 1.99999 16.07V16.08C1.99999 16.1 2.00999 16.12 2.01999 16.13V16.14C2.02999 16.16 2.03999 16.18 2.04999 16.2C2.05999 16.22 2.06999 16.23 2.07999 16.25L2.08999 16.26C2.09999 16.28 2.11999 16.29 2.12999 16.31C2.13999 16.32 2.15999 16.34 2.17999 16.35L2.18999 16.36C2.20999 16.37 2.22999 16.38 2.24999 16.4C4.82999 17.79 6.24999 19.7 6.44999 22.07C6.62999 23.91 6.00999 25.33 6.00999 25.34C6.00999 25.34 6.00999 25.34 6.00999 25.35C5.99999 25.37 5.98999 25.39 5.98999 25.41C5.98999 25.41 5.98999 25.41 5.98999 25.42C5.97999 25.44 5.97999 25.46 5.97999 25.48C5.97999 25.49 5.97999 25.49 5.97999 25.5C5.97999 25.52 5.97999 25.54 5.97999 25.56C5.97999 25.56 5.97999 25.56 5.97999 25.57C5.97999 25.59 5.97999 25.61 5.97999 25.63V25.64C5.98999 25.68 5.99999 25.72 6.01999 25.76C6.01999 25.76 6.01999 25.77 6.02999 25.77C6.03999 25.79 6.04999 25.81 6.05999 25.82C6.06999 25.84 6.08999 25.86 6.09999 25.87C6.09999 25.87 6.09999 25.87 6.09999 25.88C6.09999 25.88 6.09999 25.88 6.10999 25.89C6.11999 25.9 6.11999 25.9 6.12999 25.91C6.13999 25.92 6.13999 25.92 6.14999 25.93L6.15999 25.94C6.17999 25.95 6.18999 25.97 6.20999 25.98C6.20999 25.98 6.21999 25.98 6.21999 25.99C6.23999 26 6.24999 26.01 6.26999 26.02C6.26999 26.02 6.27999 26.02 6.27999 26.03C6.29999 26.04 6.31999 26.05 6.33999 26.05C6.33999 26.05 6.33999 26.05 6.34999 26.05C6.36999 26.06 6.38999 26.06 6.40999 26.06C6.41999 26.06 6.41999 26.06 6.42999 26.06C6.44999 26.06 6.46999 26.06 6.48999 26.06C6.50999 26.06 6.52999 26.06 6.54999 26.06C6.55999 26.06 6.55999 26.06 6.55999 26.06C6.57999 26.06 6.59999 26.05 6.61999 26.05C9.42999 25.2 11.78 25.55 13.6 27.09C14.98 28.25 15.55 29.69 15.55 29.7C15.56 29.72 15.57 29.74 15.58 29.76C15.59 29.78 15.6 29.79 15.61 29.81L15.62 29.82C15.63 29.84 15.65 29.85 15.66 29.87C15.67 29.88 15.69 29.9 15.7 29.91L15.71 29.92C15.74 29.94 15.78 29.97 15.82 29.98H15.83C15.85 29.99 15.87 29.99 15.89 30C15.91 30 15.93 30.01 15.95 30.01C15.95 30.01 15.95 30.01 15.96 30.01C15.97 30.01 15.98 30.01 15.99 30.01C16.01 30.01 16.03 30.01 16.05 30.01C16.06 30.01 16.06 30.01 16.07 30.01C16.09 30.01 16.1 30 16.12 30H16.13C16.17 29.99 16.21 29.97 16.24 29.95L16.25 29.94C16.26 29.93 16.28 29.92 16.29 29.91L16.3 29.9C16.32 29.89 16.33 29.87 16.34 29.86L16.35 29.85C16.36 29.84 16.37 29.83 16.38 29.81L16.39 29.8C16.4 29.78 16.41 29.77 16.42 29.75C17.81 27.17 19.72 25.75 22.09 25.55C23.89 25.39 25.31 26.01 25.32 26.02C25.34 26.03 25.36 26.04 25.38 26.04C25.38 26.04 25.38 26.04 25.39 26.04C25.41 26.05 25.43 26.05 25.45 26.05C25.46 26.05 25.46 26.05 25.47 26.05C25.49 26.05 25.51 26.05 25.53 26.05C25.53 26.05 25.53 26.05 25.54 26.05C25.56 26.05 25.58 26.05 25.6 26.05C25.61 26.05 25.61 26.05 25.62 26.05C25.66 26.04 25.7 26.03 25.74 26.01C25.74 26.01 25.75 26.01 25.75 26C25.77 25.99 25.79 25.98 25.8 25.97C25.82 25.96 25.84 25.94 25.85 25.93C25.85 25.93 25.85 25.93 25.86 25.93C25.86 25.93 25.86 25.93 25.87 25.92C25.88 25.91 25.88 25.91 25.89 25.9C25.9 25.89 25.9 25.89 25.91 25.88L25.92 25.87C25.93 25.85 25.95 25.84 25.96 25.82C25.96 25.82 25.96 25.81 25.97 25.81C25.98 25.79 25.99 25.78 26 25.76C26 25.76 26 25.75 26.01 25.75C26.02 25.73 26.03 25.71 26.03 25.69C26.04 25.67 26.04 25.65 26.04 25.63C26.04 25.62 26.04 25.62 26.04 25.61C26.04 25.59 26.04 25.57 26.04 25.55C26.04 25.53 26.04 25.51 26.04 25.49V25.48C26.04 25.46 26.03 25.44 26.03 25.42C25.19 22.61 25.53 20.26 27.07 18.44C28.23 17.06 29.67 16.49 29.68 16.49C29.7 16.48 29.72 16.47 29.74 16.46C29.74 16.46 29.74 16.46 29.75 16.46C29.77 16.45 29.78 16.44 29.8 16.43L29.81 16.42C29.83 16.41 29.84 16.39 29.86 16.38C29.87 16.37 29.89 16.35 29.9 16.34C29.91 16.3 29.91 16.3 29.92 16.29ZM27.79 15.5H23.64C20.8 13.9 21.56 11.45 21.74 10.98L24.6 8.12C24.52 8.65 24.49 9.27 24.54 9.93C24.75 12.54 26.22 14.32 27.79 15.5ZM11.49 19.36C11.42 18.54 11.1 17.46 10.08 16.5H14.81L11.51 19.8C11.51 19.66 11.5 19.51 11.49 19.36ZM16.51 10.13C16.61 10.23 16.72 10.33 16.83 10.43C17.43 10.94 18.36 11.45 19.68 11.45C19.74 11.45 19.79 11.45 19.85 11.45L16.51 14.79V10.13V10.13ZM15.51 14.79L12.21 11.49C12.35 11.49 12.5 11.49 12.65 11.48C13.47 11.41 14.55 11.09 15.51 10.07V14.79V14.79ZM14.8 15.5H10.14C10.24 15.4 10.34 15.29 10.44 15.18C10.97 14.55 11.51 13.57 11.46 12.16L14.8 15.5ZM15.51 17.21V21.88C15.41 21.78 15.3 21.68 15.19 21.58C14.59 21.07 13.66 20.56 12.34 20.56C12.28 20.56 12.23 20.56 12.17 20.56L15.51 17.21ZM16.51 17.21L19.81 20.51C19.67 20.51 19.52 20.51 19.37 20.52C18.55 20.59 17.47 20.91 16.51 21.93V17.21ZM17.22 16.5H21.89C21.79 16.6 21.69 16.71 21.59 16.82C21.06 17.45 20.52 18.43 20.57 19.84L17.22 16.5ZM17.22 15.5L20.52 12.2C20.52 12.34 20.52 12.49 20.53 12.64C20.6 13.46 20.92 14.54 21.94 15.5H17.22V15.5ZM17.75 5.67C19.74 7.37 22.04 7.59 23.99 7.31L21.05 10.25C17.91 11.13 16.72 8.86 16.51 8.4V4.35C16.83 4.78 17.24 5.24 17.75 5.67ZM9.93999 7.47C12.55 7.26 14.33 5.79 15.51 4.22V8.37C13.91 11.21 11.46 10.45 10.99 10.27L8.12999 7.41C8.65999 7.48 9.26999 7.52 9.93999 7.47ZM5.67999 14.26C7.37999 12.27 7.59999 9.97 7.31999 8.02L10.26 10.96C11.14 14.09 8.86999 15.29 8.40999 15.5H4.35999C4.78999 15.18 5.24999 14.77 5.67999 14.26ZM4.22999 16.5H8.37999C11.22 18.1 10.46 20.55 10.28 21.02L7.41999 23.88C7.49999 23.35 7.52999 22.73 7.47999 22.07C7.26999 19.46 5.79999 17.68 4.22999 16.5ZM14.27 26.33C12.73 25.02 11 24.59 9.39999 24.59C8.92999 24.59 8.46999 24.63 8.02999 24.69L10.97 21.75C14.11 20.87 15.3 23.14 15.51 23.6V27.65C15.19 27.22 14.78 26.76 14.27 26.33ZM22.08 24.53C19.47 24.74 17.69 26.21 16.51 27.78V23.63C18.11 20.79 20.56 21.55 21.03 21.73L23.89 24.59C23.36 24.52 22.75 24.48 22.08 24.53ZM26.34 17.74C24.64 19.73 24.42 22.03 24.7 23.98L21.76 21.04C20.88 17.9 23.15 16.71 23.61 16.5H27.66C27.23 16.82 26.77 17.23 26.34 17.74Z",
  fill: "url(#paint5_radial_28327_6675)"
});

var _ref20 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter16_f_28327_6675)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.73999 6.8125C7.39624 8.80208 7.58374 13.375 3.08374 15.75",
  stroke: "url(#paint6_linear_28327_6675)",
  strokeWidth: 0.4,
  strokeLinecap: "round"
}));

var _ref21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_iii_28327_6675",
  x: 1.98999,
  y: 1.6,
  width: 28.27,
  height: 28.61,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.25,
  dy: -0.25
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.65098 0 0 0 0 0.611765 0 0 0 0 0.694118 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_28327_6675"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.639216 0 0 0 0 0.576471 0 0 0 0 0.701961 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_28327_6675",
  result: "effect2_innerShadow_28327_6675"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.2,
  dy: 0.2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.654902 0 0 0 0 0.639216 0 0 0 0 0.670588 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_innerShadow_28327_6675",
  result: "effect3_innerShadow_28327_6675"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_28327_6675",
  x: 6.48998,
  y: 6.2813,
  width: 9.5469,
  height: 9.5624,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_6675"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_f_28327_6675",
  x: 15.6586,
  y: 2.5894,
  width: 1.01107,
  height: 13.098,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_6675"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_f_28327_6675",
  x: 15.6642,
  y: 16.451,
  width: 1.01107,
  height: 13.098,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_6675"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_f_28327_6675",
  x: 16.1775,
  y: 16.0287,
  width: 9.5469,
  height: 9.5624,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_6675"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_f_28327_6675",
  x: 2.83971,
  y: 15.3801,
  width: 13.0878,
  height: 0.999902,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_6675"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter6_f_28327_6675",
  x: 16.1775,
  y: 15.3801,
  width: 13.0878,
  height: 0.999902,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_6675"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter7_f_28327_6675",
  x: 16.177,
  y: 6.29644,
  width: 9.54736,
  height: 9.54727,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_6675"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter8_f_28327_6675",
  x: 6.48998,
  y: 16.0439,
  width: 9.54736,
  height: 9.54727,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_6675"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter9_f_28327_6675",
  x: 2.30245,
  y: 15.5156,
  width: 5.26553,
  height: 10.2658,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_6675"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter10_f_28327_6675",
  x: 6.3337,
  y: 24.5256,
  width: 10.0001,
  height: 4.94326,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_6675"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter11_f_28327_6675",
  x: 16.1149,
  y: 24.4924,
  width: 9.37509,
  height: 4.60134,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_6675"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter12_f_28327_6675",
  x: 24.5838,
  y: 15.7499,
  width: 4.68749,
  height: 9.95327,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_6675"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter13_f_28327_6675",
  x: 24.4908,
  y: 6.43743,
  width: 4.96789,
  height: 9.79702,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_6675"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter14_f_28327_6675",
  x: 15.5212,
  y: 2.3593,
  width: 10.0313,
  height: 5.13052,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_6675"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter15_f_28327_6675",
  x: 6.61495,
  y: 2.68743,
  width: 9.59384,
  height: 4.84158,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_6675"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter16_f_28327_6675",
  x: 2.5837,
  y: 6.31243,
  width: 5.00646,
  height: 9.93765,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_6675"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_28327_6675",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(5.92749 27.9375) rotate(-43.1935) scale(23.8325 23.8325)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B9ADC5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B3A9BE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_28327_6675",
  x1: 25.99,
  y1: 24.4688,
  x2: 31.8337,
  y2: 9.9375,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BFB8C8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BFB8C8",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_28327_6675",
  x1: 16.6462,
  y1: 4.28125,
  x2: 19.7693,
  y2: 0.903897,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BFB8C8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BFB8C8",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_28327_6675",
  x1: 9.22628,
  y1: 6.47809,
  x2: 9.69096,
  y2: -0.24868,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BFB8C8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BFB8C8",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_28327_6675",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(26.24 5.90625) rotate(131.378) scale(1.74916 1.33993)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C6C4C8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C6C4C8",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_28327_6675",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(30.1462 15.6875) rotate(180) scale(1.71875 1.54687)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C6C4C8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C6C4C8",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_28327_6675",
  x1: 5.95874,
  y1: 7.6875,
  x2: 3.45969,
  y2: 18.3344,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BFB8C8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BFB8C8",
  stopOpacity: 0
})));

function SvgSpiderWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiderWeb);
export default __webpack_public_path__ + "static/media/spider-web.c1701ec0.svg";
export { ForwardRef as ReactComponent };